import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertPlanReviewRequirementMutationVariables = Types.Exact<{
  object: Types.Plan_Review_Requirements_Insert_Input;
}>;


export type InsertPlanReviewRequirementMutation = { __typename?: 'mutation_root', insert_plan_review_requirements_one?: { __typename?: 'plan_review_requirements', id: any } | null };


export const InsertPlanReviewRequirementDocument = gql`
    mutation insertPlanReviewRequirement($object: plan_review_requirements_insert_input!) {
  insert_plan_review_requirements_one(object: $object) {
    id
  }
}
    `;
export type InsertPlanReviewRequirementMutationFn = Apollo.MutationFunction<InsertPlanReviewRequirementMutation, InsertPlanReviewRequirementMutationVariables>;

/**
 * __useInsertPlanReviewRequirementMutation__
 *
 * To run a mutation, you first call `useInsertPlanReviewRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlanReviewRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlanReviewRequirementMutation, { data, loading, error }] = useInsertPlanReviewRequirementMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertPlanReviewRequirementMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlanReviewRequirementMutation, InsertPlanReviewRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlanReviewRequirementMutation, InsertPlanReviewRequirementMutationVariables>(InsertPlanReviewRequirementDocument, options);
      }
export type InsertPlanReviewRequirementMutationHookResult = ReturnType<typeof useInsertPlanReviewRequirementMutation>;
export type InsertPlanReviewRequirementMutationResult = Apollo.MutationResult<InsertPlanReviewRequirementMutation>;
export type InsertPlanReviewRequirementMutationOptions = Apollo.BaseMutationOptions<InsertPlanReviewRequirementMutation, InsertPlanReviewRequirementMutationVariables>;